import { Action } from "..";

import { LasMaterialBase } from "../../types/lasMaterialBase";
import { LAS_MATERIAL_CHANGE } from "../actions/lasMaterial";

export interface LasMaterialState {
  lasMaterial: LasMaterialBase | null;
}

const initialState: LasMaterialState = {
  lasMaterial: null,
};

const lasMaterialReducer = (
  state: LasMaterialState = initialState,
  action: Action
): LasMaterialState => {
  switch (action.type) {
    case LAS_MATERIAL_CHANGE:
      return { ...state, lasMaterial: action.payload };
    default:
      return state;
  }
};

export default lasMaterialReducer;
